import React from 'react';
import { FontIcon } from 'material-ui';
import SortableList from '../../../../tc-ui/sortable-list-with-react-dnd/sortable-list';
import DraggableCard from '../../../../tc-ui/sortable-list-with-react-dnd/draggable-card';
import moment from 'moment';


const ManageExtrasOfferLeftNav = props => {
  const {
    invalidCheck,
    offersOrExtras,
    onTextFieldChangeWithKeyPath,
    addNewItem,
  } = props;
  const getPrimaryName = obj => offersOrExtras.type === 'extras'
    ? obj.extraType
    : obj.offerName;
  const getSecondaryName = obj => {
    const name = offersOrExtras.type === 'extras'
      ? obj.extraCode
      : obj.bookingCode;
    return name
      ? `(${name})`
      : '';
  };
  return (
    <div style={{ width: '300px', marginRight: '16px', borderRight: '1px solid #e0e0e0' }}>
      <SortableList
        arrayOfData={offersOrExtras.list}
        dragEnds={sorted =>
          onTextFieldChangeWithKeyPath({
            keyPath: ['offersOrExtras', 'list'],
            value: sorted,
          })}
        style={{ width: '100%' }}
        sortable
      >
        {
          offersOrExtras.list.map(obj => {
            const primaryName = getPrimaryName(obj);
            const secondaryName = getSecondaryName(obj);
            return (
              <DraggableCard
                key={obj._id}
                isDropTarget
                isDragSource
              >
                <div
                  className="flex-tc-sb"
                  style={{
                    color: 'rgba(0, 0, 0, 0.64)',
                    padding: '12px',
                    cursor: 'pointer',
                    height: 'auto',
                    borderBottom: '1px solid #e0e0e0',
                    ...(offersOrExtras.selectedId === obj._id ? { backgroundColor: '#efefef' } : {}),
                  }}
                  onClick={() => onTextFieldChangeWithKeyPath({
                    keyPath: ['offersOrExtras'],
                    value: {
                      ...offersOrExtras,
                      selectedId: obj._id,
                      createNew: false,
                      newOffer: null,
                    },
                  })}
                >
                  <div className="flex-center">
                    {
                      invalidCheck(obj) && (
                        <FontIcon className="tc-icon-report" style={{ color: '#f44336', marginLeft: '4px' }}/>
                      )
                    }
                    <div style={{ color: obj._id && obj._id.indexOf('new') > -1 ? '#00bcd4' : 'inherit' }}>
                      <small>{primaryName}</small>
                      <div style={{ fontSize: '12px' }}>{secondaryName}</div>
                    </div>
                    {
                      !(obj.ratePackages && obj.ratePackages.length)
                      && <small style={{ color: '#f44336' }}>&nbsp;to be removed</small>
                    }
                  </div>
                  <FontIcon
                    className="tc-icon-swap_vert"
                    style={{ color: 'rgba(0, 0, 0, 0.44)' }}
                  />
                </div>
              </DraggableCard>
            );
          })
        }
      </SortableList>
      <div
        style={{
          cursor: 'pointer',
          color: '#00bcd4',
          padding: '12px',
          backgroundColor: offersOrExtras.createNew ? '#e0e0e0' : '#fff',
        }}
        onClick={offersOrExtras.createNew ? () => {} : addNewItem}
      >
        + Add {offersOrExtras.type === 'offers' ? 'A Special Offer' : 'An Extra'}
      </div>
    </div>
  );
};

export default ManageExtrasOfferLeftNav;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/manage-extras-offers/left-nav.jsx